import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

import urls from 'utils/urls'
import { makeGetRequest, makePostRequest } from 'utils/api'

import CustomButton from 'Components/CustomButton/CustomButton'

import ListOperations from './ListOperations'
import { useNavigate, useLocation } from 'react-router-dom'
import CreateOperationForm from './CreateOperationForm'

import EditOperationForm from './EditOperationForm'
import ExportData from './Export'
import ImportData from './Import'

export const TempsDeTravail = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()
  const location = useLocation()

  const [operations, setOperations] = useState({})

  const [selectedRows, setSelectedRows] = useState([])
  const [jobList, setJobList] = useState([])
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selected, setSelected] = useState(false)
  const [selectedCopy, setSelectedCopy] = useState(false)

  const [general, setGeneral] = useState(true)

  useEffect(() => {
    fetchParcours()
  }, [])
  useEffect(() => {
    fetchOperations()
  }, [location.search])

  const fetchParcours = async () => {
    const url = urls.getParcoursPro + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterData = []
      data.forEach((v) => {
        filterData.push({ id: v.id, label: `${v.Name} - ${v.entreprise?.Name}` })
      })
      setJobList([...filterData])
    }
  }
  const fetchJobs = async () => {
    const res = await makeGetRequest('/api/Professional/jobs/', {}, true)
    if (res.status === 200) {
      const filterData = []
      res.data.forEach((v) => {
        filterData.push({ id: v.id, label: `${v.title}` })
      })

      setJobList(filterData)
    }
  }

  const fetchOperations = async (pagination = '') => {
    let url = `/api/Professional/workentrie-operations/?general=${general}&${location.search.slice(
      1,
    )}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
    }
  }

  const typeObj = [
    { label: 'Travail site client', id: 1 },
    { label: 'Congé', id: 2 },
    { label: 'Travail site employeur', id: 3 },
    { label: 'Télétravail', id: 4 },
    { label: 'Maladie', id: 5 },
    { label: 'Formation', id: 6 },
  ]
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('tempsTravail.alertSelectOps')) // LAP-733 (GE022)
    } else {
      // const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      // setOperations({
      //   ...operations,
      //   results: filteredOperations,
      //   count: operations.count - selectedRows.length,
      // })

      const response = await makePostRequest(
        '/api/Professional/deleteBulk-workentries/',
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations()
        console.log('Deleted Successfully')
      }
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                  setSelectedCopy(true)
                } else {
                  setSelected(false)
                  setSelectedCopy(false)
                  alert(t('tempsTravail.alertSelectOneToEdit')) // LAP-733 (GE022)
                }
              }}
            >
              {t('tempsTravail.btnCopy') /* LAP-733 (GE022) */}
            </CustomButton>
            <ExportData />
            <ImportData fetchOperations={fetchOperations} />
            <CreateOperationForm
              fetchOperations={fetchOperations}
              jobList={jobList}
              typeactivite={typeObj}
            />
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert(t('tempsTravail.alertSelectOneToEdit')) // LAP-733 (GE022)
                }
              }}
            >
              {t('tempsTravail.btnEdit') /* LAP-733 (GE022) */}
            </CustomButton>

            <CustomButton
              onClick={() => {
                deleteBulkOperations()
              }}
            >
              {t('tempsTravail.btnDelete') /* LAP-733 (GE022) */}
            </CustomButton>
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setOperations={setOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
      {selected && (
        <EditOperationForm
          setSelected={setSelected}
          selectedCopy={selectedCopy}
          setSelectedCopy={setSelectedCopy}
          params={selectedRowsParams}
          fetchOperations={fetchOperations}
          jobList={jobList}
          typeactivite={typeObj}
        />
      )}
    </>
  )
}
